import publicRequest from '@/plugin/axios/request-public.js';

// ************ 充电服务 ************
// 可选充电券列表
export const queryChargeCouponList = (data) =>
  publicRequest({
    url: '/vas/h5/order/chargeCoupon/agency/couponList',
    method: 'post',
    data
  });

// 充电券下单
export const createChargeCouponOrder = (data, noError = false) =>
  publicRequest({
    url: '/vas/h5/order/chargeCoupon/agency/create',
    method: 'post',
    noError: noError,
    data
  });

// 充电券订单预支付
export const prePayChargeCouponOrder = (data) =>
  publicRequest({
    url: '/vas/h5/order/chargeCoupon/agency/prePay',
    method: 'post',
    data
  });

// 充电券订单详情
export const queryChargeCouponDetail = (data) =>
  publicRequest({
    url: '/vas/h5/order/chargeCoupon/agency/detail',
    method: 'post',
    data
  });

// 查询代理商详情
export const queryAgencyDetail = (data) =>
  publicRequest({
    url: '/vas/h5/order/chargeCoupon/agency/queryAgencyDetail',
    method: 'post',
    data
  });

// 判断是否是代理商的工作人员
export const judgeAgentEmployee = (data) =>
  publicRequest({
    url: '/vas/h5/right/chargeAgency/judgeAgentEmployee',
    method: 'post',
    data
  });

// 注册为代理商工作人员
export const registerAgentEmployee = (data) =>
  publicRequest({
    url: '/vas/h5/right/chargeAgency/registerAgentEmployee',
    method: 'post',
    data
  });

// 生成工作人员的分享码
export const generateShareCode = (data) =>
  publicRequest({
    url: '/vas/h5/right/chargeAgency/generateShareCode',
    method: 'post',
    data
  });

// 根据手机号查询该工作人员的其他信息
export const queryRelevantInformationByEmployeePhone = (data) =>
  publicRequest({
    url: '/vas/h5/right/chargeAgency/queryRelevantInformationByEmployeePhone',
    method: 'post',
    data
  });

// 查询虾米车服服务商配置
export const queryRightCouponProviderConfig = (data) =>
  publicRequest({
    url: '/vas/h5/order/chargeCoupon/agency/queryRightCouponProviderConfig',
    method: 'post',
    data
  });

// 查询是否显示过买券指引
export const queryIsGuide = (data) =>
  publicRequest({
    url: '/vas/h5/order/chargeCoupon/agency/queryIsGuide',
    method: 'post',
    data
  });

// 更新是否显示过买券指引
export const updateIsGuide = (data) =>
  publicRequest({
    url: '/vas/h5/order/chargeCoupon/agency/updateIsGuide',
    method: 'post',
    data
  });

// 查询用户已经购买的权益卡
export const findPurchasedRight = (data) =>
  publicRequest({
    url: '/vas/h5/order/chargeCoupon/agency/findPurchasedRight',
    method: 'post',
    data
  });

// 查询用户已经购买的权益券
export const findPurchasedRightCard = (data) =>
  publicRequest({
    url: '/vas/h5/order/chargeCoupon/agency/findPurchasedRightCard',
    method: 'post',
    data
  });

// 修改统计信息
export const wxappOrderAddCount = (data) =>
  publicRequest({
    url: '/vas/h5/order/chargeCoupon/agency/addCount',
    method: 'post',
    data
  });

// 查询弹窗是否展示接口
export const queryWindowReminder = (data) =>
  publicRequest({
    url: '/vas/h5/order/chargeCoupon/agency/queryWindowReminder',
    method: 'post',
    data
  });

// 弹框近期不再展示接口
export const notShowRecently = (data) =>
  publicRequest({
    url: '/vas/h5/order/chargeCoupon/agency/notShowRecently',
    method: 'post',
    data
  });
  // 获取优惠券接口
export const getCouponApi = (data) => publicRequest({
  url: '/vas/wxapp/rightCoupon/queryFullReduction',
  method: 'post',
  data
});
